import { createSlice } from '@reduxjs/toolkit';

export const seatInfoSlice = createSlice({
  name: 'seatInfo',
  initialState: {
    selectedSeats: [],
    enteredSeats: [],
  },
  reducers: {
    updateSeats: (state, action) => {
      const { seat, selected } = action.payload;
      if (selected) {
        const selectedSeatsArr = [...state.selectedSeats, seat];
        return { ...state, selectedSeats: selectedSeatsArr };
      } else {
        const selectedSeatsArr = state.selectedSeats.filter(
          (each) => each.seatName !== seat.seatName
        );
        return { ...state, selectedSeats: selectedSeatsArr };
      }
    },
    updateEnteredSeats: (state, action) => {
      const { seatFullDetail } = action.payload;
      const updatedArr = state.selectedSeats.map((each) => {
        if (each.seatName === seatFullDetail.seatName) {
          return seatFullDetail;
        } else {
          return each;
        }
      });

      return { ...state, selectedSeats: updatedArr };
    },

    clearAll: (state) => {
      return { ...state, selectedSeats: [], enteredSeats: [] };
    },
  },
});

export const { updateSeats, clearAll, updateEnteredSeats } =
  seatInfoSlice.actions;

export default seatInfoSlice.reducer;

// {boxId:25554, isBoxPublic:1}
